export default __webpack_public_path__ + "static/media/icon_arrow-left.da5b2725.svg";